import React from 'react';
import { Link } from 'react-router-dom';
import { Crown, X, Check } from 'lucide-react';
import { Dialog, DialogContent } from './ui/dialog';

function UpgradeModal({ isOpen, onClose }) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-slate-400 hover:text-slate-600"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-purple-500 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <Crown className="w-8 h-8 text-white" />
          </div>
          <h2 className="text-3xl font-bold text-slate-900 mb-3">
            Upgrade to Access Premium Resources
          </h2>
          <p className="text-lg text-slate-600">
            Get unlimited access to all worksheets, lesson plans, and teaching materials
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-6">
          {/* Teacher Plus */}
          <div className="bg-white rounded-2xl border-2 border-blue-100 p-6 hover:border-blue-300 transition-all">
            <div className="text-center mb-4">
              <h3 className="text-2xl font-bold text-slate-900 mb-2">Teacher Plus</h3>
              <div className="text-4xl font-bold text-blue-600 mb-1">$9</div>
              <p className="text-sm text-slate-600">per month</p>
            </div>
            
            <ul className="space-y-3 mb-6">
              <li className="flex items-start gap-2 text-sm text-slate-700">
                <Check className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" strokeWidth={2.5} />
                <span><strong>All premium resources</strong> (worksheets, lesson plans, assessments)</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-slate-700">
                <Check className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" strokeWidth={2.5} />
                <span><strong>200 AI generations</strong> per month</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-slate-700">
                <Check className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" strokeWidth={2.5} />
                <span>Priority support</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-slate-700">
                <Check className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" strokeWidth={2.5} />
                <span>Advanced teaching tips</span>
              </li>
            </ul>
            
            <Link
              to="/pricing"
              onClick={onClose}
              className="block w-full bg-blue-600 text-white hover:bg-blue-700 text-center px-6 py-3 rounded-xl font-semibold shadow-sm transition-all active:scale-95"
            >
              Choose Plus
            </Link>
          </div>

          {/* Teacher Pro */}
          <div className="bg-gradient-to-br from-purple-50 to-blue-50 rounded-2xl border-2 border-purple-300 p-6 relative">
            <div className="absolute top-4 right-4 bg-purple-600 text-white text-xs font-bold px-3 py-1 rounded-full">
              POPULAR
            </div>
            
            <div className="text-center mb-4">
              <h3 className="text-2xl font-bold text-slate-900 mb-2">Teacher Pro</h3>
              <div className="text-4xl font-bold text-purple-600 mb-1">$12</div>
              <p className="text-sm text-slate-600">per month</p>
            </div>
            
            <ul className="space-y-3 mb-6">
              <li className="flex items-start gap-2 text-sm text-slate-700">
                <Check className="w-5 h-5 text-purple-600 flex-shrink-0 mt-0.5" strokeWidth={2.5} />
                <span><strong>All premium resources</strong> (worksheets, lesson plans, assessments)</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-slate-700">
                <Check className="w-5 h-5 text-purple-600 flex-shrink-0 mt-0.5" strokeWidth={2.5} />
                <span><strong>Unlimited AI generations</strong></span>
              </li>
              <li className="flex items-start gap-2 text-sm text-slate-700">
                <Check className="w-5 h-5 text-purple-600 flex-shrink-0 mt-0.5" strokeWidth={2.5} />
                <span>Priority support</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-slate-700">
                <Check className="w-5 h-5 text-purple-600 flex-shrink-0 mt-0.5" strokeWidth={2.5} />
                <span>Early access to new features</span>
              </li>
            </ul>
            
            <Link
              to="/pricing"
              onClick={onClose}
              className="block w-full bg-purple-600 text-white hover:bg-purple-700 text-center px-6 py-3 rounded-xl font-semibold shadow-sm transition-all active:scale-95"
            >
              Choose Pro
            </Link>
          </div>
        </div>

        <p className="text-center text-sm text-slate-500">
          Cancel anytime. No commitments.
        </p>
      </DialogContent>
    </Dialog>
  );
}

export default UpgradeModal;
